<div class="relative mr-5 w-full max-w-sm bg-white rounded-lg overflow-hidden border border-gray-200 shadow-sm keen-slider__slide p-3 m-1.5  relative card-scale">
  <!-- Header with badge and heart icon -->
  <div class="relative h-48 bg-gray-200 animate-pulse">
    <div class="absolute top-2 left-2 w-16 h-6 bg-gray-300 rounded animate-pulse"></div>
    <div class="absolute top-2 right-2 w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
  </div>

  <!-- Card content -->
  <div class="p-4 space-y-3">
    <!-- Title skeleton -->
    <div class="space-y-2">
      <div class="h-5 bg-gray-300 rounded-md w-3/4 animate-pulse"></div>
      <div class="h-4 bg-gray-300 rounded-md w-1/2 animate-pulse"></div>
    </div>

    <!-- Rating skeleton -->
    <div class="flex items-center gap-2">
      <div class="w-12 h-5 bg-gray-300 rounded animate-pulse"></div>
      <div class="h-4 bg-gray-300 rounded w-24 animate-pulse"></div>
    </div>

    <!-- Location skeleton -->
    <div class="flex items-center gap-2">
      <div class="w-4 h-4 bg-gray-300 rounded-full animate-pulse"></div>
      <div class="h-4 bg-gray-300 rounded w-32 animate-pulse"></div>
    </div>
  </div>
</div>
